import EzController from 'controllers/ez-base-controller';
import { getContentType } from 'lib/helpers';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import {
  CONTRIBUTOR_CLICK,
  DOWNLOAD_COMPLETE,
} from 'components/analytics/conversions/constants/actions';
import Cookies from 'js-cookie';
import { saveToLocalAndCookie, addSessionViewActivity } from 'lib/sessions-manager';
import { initTooltips } from 'ez-styles/assets/js/utils/tooltips';
import { getResourceType } from 'lib/resource-show-helpers';

export default class ResourceShowMainController extends EzController {
  static targets = [
    'resource',
    'sidebar',
    'downloadBtn',
    'attributionBlock',
    'proLicense',
    'freeLicense',
    'photoSizeBtn',
    'proLicenseDlSizes',
    'freeLicenseDlSizes',
  ];

  connect() {
    addSessionViewActivity(this.element.dataset.resourceId);
    saveToLocalAndCookie('most_recent_resource_id', this.element.dataset.resourceId);

    if (this.element.dataset.autodlPath) this.triggerResourceDownload();

    if (document.querySelector('[data-ez-tooltip="true"]')) {
      initTooltips();
    }
  }

  triggerResourceDownload() {
    const downloadSize = Cookies.get('download_size_for_checkout') || 'original';

    if (downloadSize !== 'original' && document.querySelector(`[data-controller="download-btn"][data-size="${downloadSize}"]`)) {
      setTimeout(() => { // set a timeout so the download button controller has a chance to initialize
        document.querySelector(`[data-controller="download-btn"][data-size="${downloadSize}"]`).click();
      }, 500);
    } else {
      window.location = this.element.dataset.autodlPath;
    }

    sendTrackingEvent({
      element: this.element,
      data: {
        action: DOWNLOAD_COMPLETE,
        label: getResourceType(),
        category: 'Show',
        content_type: `Content-${getContentType()}`,
      },
    });

    Cookies.remove('download_size_for_checkout');
  }

  contributorClick = (event) => {
    this.trackContributorClick(event);
  }

  trackContributorClick(event) {
    sendTrackingEvent({
      element: event.target,
      data: {
        action: CONTRIBUTOR_CLICK,
      },
    });
  }

  updateSelectedLicense(event) {
    const thisWrap = event.target.id;

    if (thisWrap === 'free-license') {
      this.showFreeHidePro();
    } else {
      this.showProHideFree();
    }
  }

  showFreeHidePro() {
    this.proLicenseTarget.removeAttribute('checked');
    this.freeLicenseTarget.setAttribute('checked', 'checked');
    this.downloadBtnTarget.firstElementChild.classList.add('hidden');
    this.downloadBtnTarget.lastElementChild.classList.remove('hidden');
    this.attributionBlockTarget.firstElementChild.classList.add('hidden');
    this.attributionBlockTarget.lastElementChild.classList.remove('hidden');
    if (this.photoSizeBtnTarget) {
      this.photoSizeBtnTarget.classList.add('license-free');
      this.photoSizeBtnTarget.classList.remove('license-pro');
      this.proLicenseDlSizesTarget.classList.add('hidden');
      this.freeLicenseDlSizesTarget.classList.remove('hidden');
    }
  }

  showProHideFree() {
    this.freeLicenseTarget.removeAttribute('checked');
    this.proLicenseTarget.setAttribute('checked', 'checked');
    this.downloadBtnTarget.lastElementChild.classList.add('hidden');
    this.downloadBtnTarget.firstElementChild.classList.remove('hidden');
    this.attributionBlockTarget.lastElementChild.classList.add('hidden');
    this.attributionBlockTarget.firstElementChild.classList.remove('hidden');
    if (this.photoSizeBtnTarget) {
      this.photoSizeBtnTarget.classList.add('license-pro');
      this.photoSizeBtnTarget.classList.remove('license-free');
      this.freeLicenseDlSizesTarget.classList.add('hidden');
      this.proLicenseDlSizesTarget.classList.remove('hidden');
    }
  }
}
